// extracted by mini-css-extract-plugin
module.exports = {"addEventButton":"CompanyEvents_addEventButton__33ZLo","eventsContainer":"CompanyEvents_eventsContainer__3HKso"};